// extracted by mini-css-extract-plugin
export default {"actorsSection":"TitleActorList_actorsSection__QbRAt","actorsTitle":"TitleActorList_actorsTitle__oKN-i","actorsList":"TitleActorList_actorsList__ADuVQ"};